import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=43303b85&scoped=true&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=43303b85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43303b85",
  null
  
)

export default component.exports